import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";
import { DimensionsEnum } from "../../../types/AppTypes";

const StyledProgressBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const StyledProgressBarContainer = styled.div<{ $size: DimensionsEnum }>`
  width: 100%;
  background-color: ${theme.colors.grey_5};
  border-radius: 50px;
  overflow: hidden;
  height: ${({ $size }) => ($size === DimensionsEnum.BIG ? "6px" : "2px")};
`;

const StyledProgressBarFiller = styled.div<{
  $progress: number;
  $color: string;
}>`
  height: 100%;
  width: ${(props) => props.$progress}%;
  background-color: ${(props) => props.$color};
  transition: width 0.5s ease-in-out;
`;

export {
  StyledProgressBar,
  StyledProgressBarContainer,
  StyledProgressBarFiller,
};
